import { z } from 'zod';
import { IdSchema, TimestampSchema } from './common.js';

export const TopicSlugSchema = z
  .string()
  .min(1)
  .max(60)
  .regex(/^[a-z0-9]+(-[a-z0-9]+)*$/, 'must be kebab-case');
export type TopicSlug = z.infer<typeof TopicSlugSchema>;

export const TopicSchema = z.object({
  id: IdSchema,
  name: z.string().min(1).max(100),
  slug: TopicSlugSchema,
  description: z.string().default(''),
  guidancePrompt: z.string().default(''),
  displayOrder: z.number().int().min(0).default(0),
  isActive: z.boolean().default(true),
  createdAt: TimestampSchema,
  updatedAt: TimestampSchema,
});
export type Topic = z.infer<typeof TopicSchema>;

export const CreateTopicSchema = TopicSchema.pick({
  name: true,
  slug: true,
  description: true,
  guidancePrompt: true,
  displayOrder: true,
  isActive: true,
}).partial({
  description: true,
  guidancePrompt: true,
  displayOrder: true,
  isActive: true,
});
export type CreateTopicInput = z.infer<typeof CreateTopicSchema>;

export const UpdateTopicSchema = CreateTopicSchema.partial();
export type UpdateTopicInput = z.infer<typeof UpdateTopicSchema>;
